<template>
  <div class="box">
    <!-- line -->
    <!-- <div class="pad-patient">
      <div style="padding: 20px;height: 70px">
        <a-button type="primary" v-if="isInput !== '1'" @click="register" v-has="'patient:register'">注册受试者</a-button>
        <label v-else></label>
        <div style="float: right">
          <a-button style="margin-right: 10px" @click="supperSearchView">高级筛选</a-button>
          <a-radio-group v-model="viewType">
            <a-radio-button value="1">
              <a-icon type="appstore" />
            </a-radio-button>
            <a-radio-button value="2">
              <a-icon type="bars" />
            </a-radio-button>
          </a-radio-group>
          <a-select style="width: 120px;margin-left: 10px" v-model="queryParam.searchType">
            <a-select-option :value="item.name" v-for="(item, index) in searchTypeList" :key="index">
              {{ item.text }}
            </a-select-option>
          </a-select>
          <a-input v-model="queryParam.searchValue" style="width: 200px;margin-left: 5px"></a-input>
          <a-button type="primary" @click="searchQueryMy" style="margin-left: 5px"> 查询</a-button>
          <a-button @click="searchResetMy" style="margin-left: 5px"> 重置</a-button>
        </div>
      </div>
      <div style="padding: 20px; margin-top: -10px">
        <div v-if="viewType === '1'" :class="'transition-' + transitionType"
          style="padding-left: 20px;padding-right: 20px" @touchstart="touchstart" @touchmove="touchmove"
          @touchend="touchend">
          <a-spin :spinning="loading">
            <transition name="patient-move">
              <a-row v-show="touchShow" :gutter="20" style="min-height: 400px"
                :class="touchShowBefore ? 'patient-move-enter2' : ''">
                <a-col :xxl="6" :lg="8" :sm="12" v-for="(item, index) in dataSource" :key="index"
                  style="margin-bottom: 20px">
                  <patient-card :pad="'1'" :data="item" @editClick="handleEdit" @viewClick="handleView"
                    :fieldList="fieldList" />
                </a-col>
              </a-row>
            </transition>


          </a-spin>
        </div>
        <div v-else>
          <a-table rowKey="id" size="middle" :columns="columns" :dataSource="dataSource" :pagination="ipagination"
            :loading="loading" :scroll="{ x: 1200 }" @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handleView(record)">查看</a>
              <a-divider type="vertical" v-has="'patient:register'" />
              <a @click="handleEdit(record)" v-has="'patient:register'">编辑</a>
            </span>
            <span slot="status" slot-scope="text, record, index">
              <status-tag :status="text"></status-tag>
            </span>
          </a-table>
        </div>
      </div>
      <patient-edit :width="'100%'" ref="patient-edit" :fieldList="fieldList" @ok="modalFormOk"></patient-edit>

    </div> -->
    <!-- line -->
    <new-header :title="title" @back="back"></new-header>
    <div class="wrap">
      <div class="top1">
        <!-- <a-button type="primary" class="reg" v-if="isInput !== '1'" @click="register" v-has="'patient:register'"> -->
        <a-button type="primary" class="reg" @click="register">
          <!-- <registry></registry> -->
          <span>注册受试者</span>
        </a-button>
        <div class="right">
          <a-input-group compact class="search">
            <a-select v-model="queryParam.searchType">
              <a-select-option :value="item.name" v-for="(item, index) in searchTypeList" :key="index">
                {{ item.text }}
              </a-select-option>
            </a-select>
            <a-input v-model="queryParam.searchValue" style="width: 40%"></a-input>
          </a-input-group>
          <a-button type="primary" class="btn btn1" @click="searchQueryMy">
            查询
          </a-button>
          <a-button class="btn btn2" @click="searchResetMy">
            重置
          </a-button>
          <a-button class="filter" @click="supperSearchView">
            <span>高级筛选</span>
            <a-icon type="filter" />
          </a-button>
          <a-button-group>
            <a-button :class="['btn3', viewType === '1' && 'cur']" @click="viewType = '1'">
              <sort-one :color="viewType === '1' ? 'white' : 'rgba(55, 110, 255, 1)'"></sort-one>
            </a-button>
            <a-button :class="['btn3', viewType === '2' && 'cur']" @click="viewType = '2'">
              <sort-two :color="viewType === '2' ? 'white' : 'rgba(55, 110, 255, 1)'"></sort-two>
            </a-button>
          </a-button-group>
        </div>
      </div>

      <div v-if="viewType === '1'" style="margin-top: 10px;">
        <a-spin :spinning="loading">
          <div class="scroll-wrap" ref="scroll-wrap">
            <div class="list" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend" ref="list">
              <div class="main" v-for="item in dataSource" :key="item.id">
                <div class="title">
                  <img :src="require(`@/assets/${item.sex === '0' ? 'lady' : 'gentlemen'}.jpg`)" width="40" alt="" />
                  <div class="info">
                    <div class="info1">
                      <strong v-if="getRctInfo(item)==''">{{ item.name }}</strong>
                      <a-tag v-else :color=" 'blue'">
                        <strong style="color: blue;">{{ item.name }}</strong> 
                      </a-tag>
                      <a-tag :color="item.sex_dictText === '男' ? 'rgba(55, 110, 255, 1)' : 'red'">
                        {{ item.sex_dictText }}
                      </a-tag>
                      <a-tag color="rgba(193, 200, 216, 1)">
                        {{ item.age }}岁
                      </a-tag>
                      <b>{{ item.personName }}</b>                   
                    </div>
                    <div class="info2">
                      <span>受试者编号</span>
                      <span>{{ item.patientNum }}</span>
                      <b style="color: blue;">{{ getRctInfo(item) }}</b>
                    </div>
                  </div>
                </div>

                <a-row class="row1" :gutter="32">
                  <template v-for="(data, index) in defineFieldList">
                    <a-col :span="index % 2 === 0 ? 15:9" :key="index" v-if="index < 4">
                      <em>{{ data.name || '-' }}</em>
                      <strong>{{ item.defineField[data.id] || '-' }}</strong>
                    </a-col>
                  </template>
                  <template v-for="(data, index) in item.periodGroups">
                    <a-col :span="index % 2 === 0 ? 15:9" :key="index" v-if="index < 2">
                      <em>{{ data.groupName || '-' }}</em>
                      <strong>{{ data.status==="1"?'手术期':data.status==="2"?'已终止':'戴牙后' }}</strong>
                    </a-col>
                  </template>                  
                </a-row>

                <a-row class="row1" :gutter="32">
                  <a-col :span="15">
                    <em>随访进度</em>
                    <div style="display: flex;">
                      <status-tag :status="item.status"></status-tag>
                      <b>{{ item.createTime.substring(0, 10) }}</b>
                    </div>
                  </a-col>
                  <a-col :span="9">
                    <em>随访表单</em>
                    <strong>{{ item.formSubmitSum }}/{{ item.formSum }}</strong>
                  </a-col>
                </a-row>

                <!-- <a-row class="row1" :gutter="32">
                  <a-col :span="24">
                    <span class="form-data">表单：{{ item.formSubmitSum }}/{{ item.formSum }}</span>
                  </a-col>
                </a-row> -->
                <a-row class="row1" :gutter="32" style="display: flex;align-items: center;">
                  <a-col :span="12">
                    <a-tag :color="'blue'">{{ item.inPeriodItemName||'无' }}</a-tag>
                  </a-col>
                  <a-col :span="12">
                    <!-- <div class="progress">
                      <span class="sp1">完成填充进度</span>
                      <span class="sp2">{{ formNormalProgress(item) }}%</span>
                    </div>
                    <a-progress :percent="formNormalProgress(item)" status="active" :showInfo="false" /> -->
                    <div class="progress">
                      <span class="sp1">表单完成进度</span>
                      <span class="sp2">{{ formProgress(item) }}%</span>
                    </div>
                    <a-progress :percent="formProgress(item)" status="active" :showInfo="false" />
                  </a-col>
                </a-row>
                <a-row class="row1" :gutter="32">
                  <a-col :span="12">
                    <a-button block class="btn" @click="handleEdit(item)">
                      编辑
                    </a-button>
                  </a-col>
                  <a-col :span="12">
                    <a-button block class="btn" @click="handleView(item)">
                      查看
                    </a-button>
                  </a-col>
                </a-row>

              </div>
            </div>
          </div>
        </a-spin>
        <!-- <br> -->
      
        <a-empty v-if="dataSource.length === 0"  style="margin-top: 10px;">
          <span slot="description">暂无数据</span>
        </a-empty>
        <a-row v-else style="margin-top: 10px;">
          <a-col :span="24" style="text-align: center; font-size:16px">
            <!-- <a-pagination :show-total="total => `共 ${total} 条`" show-quick-jumper :current="ipagination.current"
              :pageSize="ipagination.pageSize" :total="ipagination.total" @change="pageChange" /> -->
            <span>共 {{this.ipagination.total}} 条数据</span>
          </a-col>          
        </a-row>
      </div>
      <div v-else>
        <a-table rowKey="id" size="middle" :columns="columns" :dataSource="dataSource" :pagination="ipagination"
          :loading="loading" :scroll="{ x: 1200 }" @change="handleTableChange">
          <span slot="action" slot-scope="text, record">
            <a @click="handleView(record)">查看</a>
            <a-divider type="vertical" v-has="'patient:register'" />
            <a @click="handleEdit(record)" v-has="'patient:register'">编辑</a>
          </span>
          <span slot="status" slot-scope="text, record, index">
            <status-tag :status="text"></status-tag>
          </span>
        </a-table>
      </div>

      <patient-edit :width="'80%'" ref="patient-edit" :fieldList="fieldList" @ok="modalFormOk" @loadOne="reloadPatient"></patient-edit>
      <a-drawer title="高级筛选" :width="'80%'" :visible="supperSearchVisible" :closable="true" :key="dataSourceSupperKey"
          @close="handleSupperSearchCancel">
          <a-checkbox-group v-model="queryParam2.centerIdList" class="advanced-row">
            <a-row>
              <a-col :span="4" class="advanced-label">
                研究中心：
              </a-col>
              <a-col :span="20">
                <a-row>
                  <a-col :span="8" v-for="(center, index) in centerList" :key="index">
                    <a-checkbox :value="center.center.id">
                      {{ center.center.name }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <a-checkbox-group v-model="queryParam2.userIdList" class="advanced-row">
            <a-row>
              <a-col :span="4" class="advanced-label">
                研究员：
              </a-col>
              <a-col :span="20">
                <a-row>
                  <a-col :span="8" v-for="(user, index) in userList" :key="index">
                    <a-checkbox :value="user.userId">
                      {{ user.realname }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <!-- <a-checkbox-group v-model="queryParam2.groupIdList" class="advanced-row">
            <a-row>
              <a-col :span="4" class="advanced-label">
                组别：
              </a-col>
              <a-col :span="20">
                <a-row>
                  <a-col :span="8" v-for="(item, index) in groupList" :key="index">
                    <a-checkbox :value="item.id">
                      {{ item.name }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-checkbox-group> -->
          <a-checkbox-group v-model="queryParam2.statusList" class="advanced-row">
            <a-row>
              <a-col :span="4" class="advanced-label">
                受试者状态：
              </a-col>
              <a-col :span="20">
                <a-row>
                  <a-col :span="8" v-for="(item, index) in patientStatusList" :key="index">
                    <a-checkbox :value="item.value">
                      {{ item.text }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <a-row class="advanced-row">
            <a-col :span="4" class="advanced-label">
              注册日期：
            </a-col>
            <a-col :span="20">
              <a-range-picker v-model="queryParam2.createTimeList" valueFormat="YYYY-MM-DD" />
            </a-col>
          </a-row>
          <a-row class="advanced-row">
            <a-col :span="4" class="advanced-label">
              通过筛选日期：
            </a-col>
            <a-col :span="20">
              <a-range-picker v-model="queryParam2.passDateList" valueFormat="YYYY-MM-DD" />
            </a-col>
          </a-row>
          <a-row class="advanced-row">
            <a-col :span="4" class="advanced-label">
              终止筛选日期：
            </a-col>
            <a-col :span="20">
              <a-range-picker v-model="queryParam2.noPassDateList" valueFormat="YYYY-MM-DD" />
            </a-col>
          </a-row>
          <a-checkbox-group v-model="queryParam2.periodItemIdList" class="advanced-row">
            <a-row>
              <a-col :span="4" class="advanced-label">
                正在随访的周期：
              </a-col>
              <a-col :span="20">
                <a-row>
                  <a-col :span="8" v-for="(periodItem, index) in periodItemList" :key="index">
                    <a-checkbox :value="periodItem.id">
                      {{ periodItem.name }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <a-row class="advanced-row">
            <a-col :span="4" class="advanced-label">
              基点日期：
            </a-col>
            <a-col :span="20">
              <a-range-picker v-model="queryParam2.baseDateList" valueFormat="YYYY-MM-DD" />
            </a-col>
          </a-row>
          <a-row class="advanced-row">
             <a-col :span="4" class="advanced-label">
          自定义筛选周期：
        </a-col>
            <a-col :span="2" class="advanced-label">
              <a-input-group compact class="search">
                <a-select v-model="queryParam2.periodItemId" style="min-width:120px" placeholder="请选择周期" allow-clear>
                  <a-select-option :value="periodItem.id" v-for="(periodItem, index) in periodItemList" :key="index">
                    {{ periodItem.name }}
                  </a-select-option>
                </a-select>                
              </a-input-group>
            </a-col>
            <a-col :span="16">
              <a-range-picker v-model="queryParam2.periodDateList" valueFormat="YYYY-MM-DD" />
            </a-col>
          </a-row>
          <a-row class="advanced-row" v-if="projectId=='1781156370223149057'">
            <a-col :span="4" class="advanced-label">
              RCT入组：
            </a-col>
            <a-col :span="20">
              <a-checkbox  v-model="queryParam2.rct">RCT</a-checkbox>            
            </a-col>
          </a-row>
          <div style="text-align: right;margin-top: 20px">
            <a-button @click="handleSupperSearchCancel">取消</a-button>
            <a-button @click="handleSupperSearchSubmit" type="primary" style="margin-left: 20px">确定</a-button>
          </div>
        </a-drawer>
    </div>
    <patient-edit :width="'100%'" ref="patient-edit" :fieldList="fieldList" @ok="modalFormOk" @loadOne="reloadPatient" @toggleConsentForm="toggleConsentForm"></patient-edit>
    <consent-form :visible="visible" :patientId="patientId" :projectId="projectId"  @toggleConsentForm="toggleConsentForm"/>
  </div>
</template>

<script>
import PatientCard from '@/views/project/patient/components/PatientCard'
import StatusTag from '@/views/project/patient/components/StatusTag'
import PatientEdit from '@/views/project/patient/components/PatientEdit'
import Registry from '@comp/Icon/Registry'
import SortOne from '@comp/Icon/SortOne'
import SortTwo from '@comp/Icon/SortTwo'
import NewHeader from '@comp/pad/NewHeader'
import ConsentForm from '@/views/apppad/projectTemplate/ConsentForm'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction, putAction } from '@/api/manage'
import { CACHE_PROJECT_ID } from '@/constants/project'
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Index',
  components: { PatientEdit, StatusTag, PatientCard, Registry, SortOne, SortTwo, NewHeader,ConsentForm },
  mixins: [JeecgListMixin],
  data() {
    return {
      visible:false,
      patientId:'',
      cacheKEY: 'CACHE_PATIENT_LOAD_INFO',
      cachePeriodKEY: 'CACHE_PERIOD_LOAD_INFO',
      projectId: '',
      periodId: '',
      loading: false,
      viewType: '1',
      title:'',
      queryParam: {
        searchType: 'name',
        searchValue: '',
      },
      searchTypeListDefault: [
        { name: 'name', text: '受试者姓名' },
        { name: 'patient_num', text: '受试者编号' },
        { name: 'idcard', text: '身份证号' },
        // { name: 'eid', text: 'EID' },
      ],
      searchTypeList:[],
      disableMixinCreated: true,
      url: {
        list: '/patient/patient/list',
      },
      concernIndicatorList: [],
      trendIndicatorList: [],
      fieldList: [],
      baseColumns: [
        {
          title: '受试者编号',
          fixed: 'left',
          align: 'center',
          width: 120,
          ellipsis: true,
          dataIndex: 'patientNum'
        },
        // {
        //   fixed: 'left',
        //   title: 'EID',
        //   align: 'center',
        //   width: 100,
        //   ellipsis: true,
        //   dataIndex: 'eid'
        // },
        {
          title: '受试者姓名',
          align: 'center',
          fixed: 'left',
          width: 120,
          ellipsis: true,
          key: 'name',
          dataIndex: 'name'
        },
        {
          title: '受试者信息',
          children: [
            {
              title: '性别',
              align: 'center',
              width: 80,
              ellipsis: true,
              key: 'sex',
              dataIndex: 'sex_dictText',
            },
            {
              title: '年龄',
              align: 'center',
              width: 80,
              ellipsis: true,
              dataIndex: 'age'
            },

          ]
        },
        {
          title: '入组信息',
          children: [
            {
              title: '研究中心',
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: 'centerName'
            },
            {
              title: '研究员',
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: 'personName'
            },
            {
              title: '状态',
              align: 'center',
              width: 100,
              ellipsis: true,
              scopedSlots: { customRender: 'status' },
              dataIndex: 'status'
            },
            {
              title: '注册日期',
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: 'createTime'
            },
            {
              title: '通过筛选日期',
              align: 'center',
              width: 140,
              ellipsis: true,
              dataIndex: 'passDate'
            },
            // {
            //   title: '组别',
            //   align: 'center',
            //   width: 100,
            //   ellipsis: true,
            //   dataIndex: 'groupName'
            // },
            {
              title: '基点日期',
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: 'baseDate'
            },
          ]
        },
      ],
      isInput: null, //是否从可执行随访处来的
      ipagination: {
        current: 1,
        pageSize: 9,
        pageSizeOptions: ['6', '9', '12'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      queryParam2: {},
      supperSearchVisible: false,
      userList: [],
      centerList: [],
      periodItemList: [],
      groupList: [],
      patientStatusList: [
        { value: '1', text: '筛选期' },
        { value: '2', text: '随访期' },
        { value: '3', text: '终止筛选' },
        { value: '4', text: '终止随访' },
        { value: '5', text: '随访完成' },
      ],
      touchInfo: {
        startY: 0,
        endY: 0,
      },
      touchShow: true,
      transitionType: 'left',
      touchShowBefore: false,
      scrollTop:0,
      dataSourceSupperKey:0,
    }
  },
  computed: {
    columns() {
      const columns = JSON.parse(JSON.stringify(this.baseColumns))
      if (this.fieldList.length > 0) {
        this.fieldList.forEach(item => {
          if (item.type === '2') {
            columns[3].children.push({
              title: item.name,
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: 'defineField.' + item.id
            })
          }
        })
      }
      if (this.concernIndicatorList.length > 0) {
        this.concernIndicatorList.forEach(item => {
          columns.push({
            title: item.name,
            align: 'center',
            width: 100,
            ellipsis: true,
            dataIndex: item.id
          })
        })
      }
      columns.push({
        title: '操作',
        dataIndex: 'action',
        width: 100,
        fixed: 'right',
        scopedSlots: { customRender: 'action' },
        align: 'center'
      })
      return columns
    },
    defineFieldList() {
      const list = []
      this.fieldList.forEach(item => {
        if (item.type === '2') {
          list.push(item)
        }
      })
      return list
    },
    isPI(){
      return this.roles().some(role => 'PROJECT_PI' === role.roleCode)
    },    
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(to, from) {
        if(from !== undefined && from.path === '/pad/index'){
          this.scrollTop = 0;
          this.projectId = this.$route.query.projectId
          this.periodId = this.$route.query.periodId
          // console.log("this.projectId1:" + this.projectId)
          this.dataSourceSupperKey++
          this.initData();
        }
      }
    }
  },
  mounted() {
    this.projectId = this.$route.query.projectId;
    this.periodId = this.$route.query.periodId
    // console.log("this.projectId2:" + this.projectId)
    this.initData();
  },
  activated() {
    // const id = this.$route.query.projectId
    // console.log(id,this.projectId);
    // if(id !== this.projectId){
    //   this.scrollTop = 0;
    //   this.projectId = id;
    //   this.initData();
    // }
    // console.log("this.projectId3:" + this.projectId)
    // console.log("queryParam2.userIdList:"+ this.queryParam2.userIdList)
    this.reloadPatient()
    this.getProjectDetail();
    if(this.viewType==="1"){
      this.$refs['scroll-wrap'].scrollTop = this.scrollTop;
    }
  },
  methods: {
    ...mapGetters(["roles", "userInfo"]),
    back(){
      this.setScrollTop();
      this.$router.push({path:'/pad/index'})
    },
    toggleConsentForm(flag){
      this.visible = flag;
    },
    touchstart(e) {
      this.touchInfo.startY = e.touches[0].clientY
    },
    touchmove(e) {
    },
    touchend(e) {
      this.touchInfo.endY = e.changedTouches[0].clientY
      const moveY = this.touchInfo.endY - this.touchInfo.startY
      this.touchInfo = {
        startY: 0,
        endY: 0,
      }
      // //移动了100距离才视为滑动事件
      // if (moveY >= 100) {
      //   this.transitionType = 'right'
      //   this.swipeRight()
      // }
      // if (moveY <= -100) {
        // this.transitionType = 'left'
        // this.swipeLeft()
      // }

      const wrap = this.$refs['scroll-wrap']; 
      const h1 = wrap.offsetHeight;
      const scrollTop = wrap.scrollTop;
      const h2 = this.$refs['list'].offsetHeight;

      if(this.viewType==="1"){
        // this.scrollTop = scrollTop
        // sessionStorage.setItem('patientListScrollPosition', scrollTop);
      }

      if(h2 > h1){
        if(scrollTop >= h2 - h1 - 100){
          if(this.len === 0){
            return this.$message.warning("暂无更多数据")
          }
          this.ipagination.current += 1;
          this.loadData(2);
        }
      }
    },
    loadDataBefore() {
      this.$nextTick(() => {
        this.touchShow = false
        this.$nextTick(() => {
          setTimeout(() => {
            this.touchShowBefore = true
            this.touchShow = true
            this.$nextTick(() => {
              setTimeout(() => {
                this.touchShowBefore = false
              }, 240)
            })
          }, 240)
        })
      })
    },
    /**
     * 左滑动事件  从左往右
     */
    swipeLeft() {
      if (this.ipagination.total > 0 && this.ipagination.pageSize > 0) {
        let pageCount = 0;
        if (this.ipagination.total % this.ipagination.pageSize === 0) {
          pageCount = parseInt(this.ipagination.total / this.ipagination.pageSize);
        } else {
          pageCount = parseInt(this.ipagination.total / this.ipagination.pageSize) + 1;
        }
        if (this.ipagination.current < pageCount) {
          this.ipagination.current = this.ipagination.current + 1
          this.loadData()
        }
      }

    },
    /**
     * 右滑动事件  从右往左
     */
    swipeRight() {
      if (this.ipagination.current > 1) {
        this.ipagination.current = this.ipagination.current - 1
        this.loadData()
      }
    },
    async getProjectDetail(){
      const res = await getAction('/management/project/getProjectDetail', { id:this.projectId })
      if (res.success && res.result) {
        this.title = res.result.name
      }
    },
    getRctInfo(item) {
      if (item.rctStatus==='1') {
        return '待定'
      }else if(item.rctStatus==='2'){
        const rctConfig = JSON.parse(item.rctConfig)
        let rctContent=rctConfig.rctGroup
        if(rctConfig.rctInterfere.status==='0'){
          rctContent+='-完成'
        }else{
           rctContent+='-未完成'
        }
        return rctContent
      }else{
        return ''
      }
    },
    initData(){
      if (sessionStorage.getItem(this.cachePeriodKEY)) {
        sessionStorage.removeItem(this.cachePeriodKEY)
      }
      this.baseQueryParam = { projectId: this.projectId }

      this.isInput = this.$route.query.input || ''
      if (this.isInput === '1') {
        this.baseQueryParam.assignmentPersonId = this.userInfo().id
      }
      Vue.ls.set(CACHE_PROJECT_ID, this.projectId)
      // if (sessionStorage.getItem(this.cacheKEY)) {
      //   const cacheInfo = JSON.parse(sessionStorage.getItem(this.cacheKEY))

      //   this.ipagination = cacheInfo.ipagination
      //   this.queryParam = cacheInfo.queryParam
      //   this.queryParam2 = cacheInfo.queryParam2
      // } else {
        // this.resetSupperParams()
      // }
      this.loadSearchData()
      this.resetSupperParams()
      console.log("this.periodId:"+this.periodId)
      if(this.periodId){
        this.$set(this.queryParam2, 'periodItemIdList', [this.periodId])
        this.$set(this.queryParam, 'supper', JSON.stringify(this.queryParam2))
      }

      if(this.viewType==="1"){
        this.loadData(1)
      }else{
        this.loadData()
      }
      //当前页面 添加了keepalive 缓存，需要将之前push进入searchTypeList 清空
      this.searchTypeList = []
      this.searchTypeList = [...this.searchTypeListDefault];
      
      getAction('/project/projectPatientField/list', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.fieldList = res.result
          this.fieldList.forEach(item => {
            if (item.type === '2') {
              this.searchTypeList.push({
                name: item.id,
                text: item.name
              })
            }
          })
        }
      })
      getAction('/project/projectConcernIndicator/list', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.concernIndicatorList = res.result
        }
      })
      getAction('/project/projectTrendIndicator/list', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.trendIndicatorList = res.result
        }
      })
    },
    handleSupperSearchSubmit() {
      this.$set(this.queryParam, 'searchValue', null)
      this.$set(this.queryParam, 'searchType', 'name')
      this.$set(this.queryParam, 'supper', JSON.stringify(this.queryParam2))
      this.periodId = ''
      this.loadData(1);
      this.handleSupperSearchCancel()
    },
    handleSupperSearchCancel() {
      this.supperSearchVisible = false
    },
    supperSearchView() {
      // this.resetSupperParams()
      this.supperSearchVisible = true
    },
    resetSupperParams() {
      this.$set(this.queryParam2, 'centerIdList', [])
      this.$set(this.queryParam2, 'userIdList', [])
      this.$set(this.queryParam2, 'groupIdList', [])
      this.$set(this.queryParam2, 'statusList', [])
      this.$set(this.queryParam2, 'createTimeList', [])
      this.$set(this.queryParam2, 'passDateList', [])
      this.$set(this.queryParam2, 'noPassDateList', [])
      this.$set(this.queryParam2, 'periodItemIdList', [])
      this.$set(this.queryParam2, 'baseDateList', [])
      this.$set(this.queryParam, 'supper', "")
      this.$set(this.queryParam, 'searchType', 'name')
      this.$set(this.queryParam, 'searchValue', null)
      this.$set(this.queryParam2,'rct',false)
    },
    loadSearchData() {
      getAction('/project/center/listAll', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.centerList = res.result
        }
      })
      getAction('/project/projectUser/listAll', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.userList = res.result
        }
      })
      getAction('/project/projectPeriodItem/list', { projectId: this.projectId, halfway: '0' }).then(res => {
        if (res.success) {
          this.periodItemList = res.result
        }
      })
      getAction('/project/projectGroup/list', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.groupList = res.result
        }
      })
    },
    searchQueryMy() {
      // this.resetSupperParams()
      this.searchQuery()
    },
    searchResetMy() {
      this.queryParam.searchValue = ''
      this.resetSupperParams()
      this.loadData(1);
    },
    resetSupperParams(){
        this.$set(this.queryParam2,'centerIdList',[])
        this.$set(this.queryParam2,'userIdList',[])
        this.$set(this.queryParam2,'groupIdList',[])
        this.$set(this.queryParam2,'statusList',[])
        this.$set(this.queryParam2,'createTimeList',[])
        this.$set(this.queryParam2,'passDateList',[])
        this.$set(this.queryParam2,'noPassDateList',[])
        this.$set(this.queryParam2,'periodItemIdList',[])
        this.$set(this.queryParam2,'baseDateList',[])
        this.$set(this.queryParam2,'formIdList',[])
        this.$set(this.queryParam2,'rct',false)
        this.$set(this.queryParam,'supper',"")
        this.$set(this.queryParam, 'searchType', 'name')
        this.$set(this.queryParam, 'searchValue', null)
      },

    register() {
      this.$refs['patient-edit'].edit({ projectId: this.projectId })
    },
    restoreScrollPosition(){
      const savedScrollPosition = sessionStorage.getItem('patientListScrollPosition');
      console.log("savedScrollPosition:"+savedScrollPosition)
      if (savedScrollPosition) {
        this.$refs['scroll-wrap'].scrollTop = savedScrollPosition
        sessionStorage.removeItem('patientListScrollPosition'); // 清除已使用的滚动位置

        
      }else{
        this.initData()
      }
    },
    reloadPatient(){
      //重新加载当前受试者信息
        const patientNum = sessionStorage.getItem('patientNumScroll');
        if(patientNum){
          let patient = this.dataSource.find(p => p.patientNum === patientNum);
          if(!patient){
            return
          }
          getAction('/patient/patient/list', { projectId: this.projectId,searchType: 'patient_num',searchValue: patientNum }).then(res => {
            if (res.success && res.result && res.result.records && res.result.records.length>0) {
              
              this.dataSource = this.dataSource.map(item => {
                if (item.patientNum === patientNum) {
                  return res.result.records[0];
                }
                return item;
              });
            }
          })
        }
    },
    handleView(record) {
      // if(this.viewType==="1"){
      //   sessionStorage.setItem('patientListScrollPosition', this.scrollTop);
        sessionStorage.setItem('patientNumScroll', record.patientNum);
      // }
      // this.$router.push({path:'/project/patient/registerview/'+record.id})
      this.setScrollTop();
      this.$router.push({ path: '/pad/patient/registerview/' + record.id })
    },
    setScrollTop(){
      if(this.viewType==="1"){
        this.scrollTop = this.$refs['scroll-wrap'].scrollTop;
        // console.log('setScrollTop',this.scrollTop)
      }      
    },
    handleEdit(record) {
      sessionStorage.setItem('patientNumScroll', record.patientNum);
      this.$refs['patient-edit'].edit(record);
      this.patientId = record.id;
    },
    pageChange(page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    loadDataCallback() {
      // 缓存当前页码和查询参数
      // sessionStorage.setItem(this.cacheKEY, JSON.stringify({
      //   ipagination: this.ipagination,
      //   queryParam: this.queryParam,
      //   queryParam2: this.queryParam2
      // }));


      this.dataSource.forEach(record => {
        this.$set(record, 'defineField', record.defineField || {})
        if (record.fieldValueList) {
          record.fieldValueList.forEach(item => {
            this.$set(record.defineField, item.fieldId, item.value)
          })
        }
      })
      this.dataSource.forEach(item => {
        if (!item.indicatorList) {
          return
        }
        item.indicatorList.forEach(indicator => {
          this.$set(item, indicator.id, indicator.value)
        })
      })
    },
    formProgress(item){
      const rate = ((item.formSubmitSum || 0) / (item.formSum || 100)) * 100
      return parseFloat(rate.toFixed(2))
      },
    formNormalProgress(item){
      const rate = ((item.formNormalSubmitSum || 0)/(item.formSum || 100))*100
      return parseFloat(rate.toFixed(2))
    },
  }
}
</script>

<style scoped lang="less">
@color1: rgba(55, 110, 255, 1);

.advanced-row {
  width: 100%;
  margin-bottom: 18px;
}

.advanced-label {
  text-align: right;
  font-size: 16px;
}

/deep/ .ant-checkbox-wrapper{
  font-size: 16px;
}

.box {
  overflow: hidden;
  min-height: 100vh;
  background:#f5f6fa url(~@/assets/bg03.png) center top no-repeat;
  background-size: contain;
}

.wrap{
  padding: 20px;
  height: calc(100vh - 41px);
}

.top1 {
  display: flex;
  align-items: center;

  .reg {
    // width: 193px;
    //height: 54px;
    width: 130px;
    height: 44px;
    background-color: @color1;
    border-color: @color1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-size: 18px;
      // margin-left: 12px;
    }
  }

  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 10px;
    margin-left: auto;

    .search {
      margin-left: 10px;
      border-radius: 55px;
      /deep/ .ant-select-selection {
        height: 40px;
        border-radius: 55px 0 0 55px;
      }

      /deep/ .ant-select-selection__rendered {
        line-height: 40px;
      }

      /deep/ .ant-input{
        height: 40px;
        border-radius: 0 55px 55px 0;
      }
    }

    .btn {
      // padding: 0 33px;
      height: 40px;
      border-radius: 8px;
      // margin-left: 20px;
    }

    .btn1 {
      background-color: @color1;
      border-color: @color1;
    }

    .filter {
      width: 106px;
      // margin:0 20px;
    }

    .btn3 {
      padding: 0 11px;
    }

    .cur {
      background-color: @color1;
      border-color: @color1;
    }
  }
}

.top2 {
  padding: 20px 0;
  text-align: right;

  .filter {
    width: 106px;
    margin-right: 20px;
  }

  .btn3 {
    padding: 0 11px;
  }

  .cur {
    background-color: @color1;
    border-color: @color1;
  }
}

.scroll-wrap::-webkit-scrollbar{
  display: none;
}

.scroll-wrap{
  overflow: auto;
  padding: 20px 0;
}

@media screen and (orientation:landscape){
  .scroll-wrap{
    height: 580px;
  }
}

@media screen and (orientation:portrait){
  .scroll-wrap{
    height: 865px;
  }
}

.list {
  display: grid;
  // grid-template-columns: repeat(3,308px);
  grid-template-columns: repeat(auto-fit, 308px);
  justify-content: center;
  column-gap: 15px;
  row-gap: 20px;
}

.main {
  overflow: hidden;
  height: 265px;
  border-radius: 12px;
  padding: 15px 20px;
  cursor: pointer;
  background: #fff url(~@/assets/bg02.png) right top no-repeat;
  box-shadow: 3px 3px 6px #888888;

  .title {
    display: flex;
    align-items: center;
  }

  .info {
    margin-left: 5px;

    .info1 {
      display: flex;
      align-items: center;

      strong {
        font-weight: 600;
        font-size: 16px;
        color: #48494D;
        margin-right: 15px;
      }
    }

    .info2 {
      display: flex;
      align-items: center;

      span {
        font-weight: 400;
        font-size: 12px;
        color: #77797E;
        margin-right: 10px;
      }
    }
  }

  .row1 {
    // margin-top: 15px;

    em {
      display: block;
      font-weight: 400;
      font-size: 12px;
      color: #77797E;
      font-style: normal;
    }

    strong {
      overflow: hidden;
      display: block;
      font-weight: 600;
      font-size: 14px;
      color: #48494D;
      word-break: keep-all;
      text-overflow: ellipsis;
    }

    b {
      font-weight: 600;
      font-size: 14px;
      color: #48494D;
    }

    .form-data {
      font-weight: 400;
      font-size: 12px;
      color: #77797E;
    }

    .progress {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .sp1 {
        font-weight: 400;
        font-size: 12px;
        color: #77797E;
      }

      .sp2 {
        font-weight: bold;
        font-size: 12px;
        color: #48494D;
      }
    }

    .btn {
      height: 36px;
      background: #EAF0FF;
      border-radius: 8px 8px 8px 8px;
      font-weight: 600;
      font-size: 14px;
      color: #376EFF;
    }
  }

}

.ant-btn:hover,
.ant-btn:focus {
  border-color: @color1
}
</style>
<style lang="less">
.ant-modal {
  top: 0;
  padding-bottom: 0;
}

/* 设置持续时间和动画函数 */
.patient-move-enter-active {
  transition: all .5s ease;
}

.patient-move-leave-active {
  transition: all .5s ease;
}

.transition-left {
  .patient-move-enter2 {
    transform: translateX(100vw) !important;
    opacity: 0;
  }

  .patient-move-leave-to {
    transform: translateX(-100vw);
    opacity: 0;
  }
}

.transition-right {
  .patient-move-enter2 {
    transform: translateX(-100vw) !important;
    opacity: 0;
  }

  .patient-move-leave-to {
    transform: translateX(100vw);
    opacity: 0;
  }
}
  .ant-calendar-picker-clear{
    opacity:100
  }
</style>